import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import store from "../store/index";
import { setupSteps } from "../utils/processTracks";
import { protectedRoutes, starterNotAllowed, enterpriseOnly, adminOnly, auditorOnly } from "./routePermissions";

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  mode: 'history',
  base: "/",
});

router.beforeEach(async (to, from, next) => {
  await store.dispatch('admin/getAppState')
    .then(async (res) => {
      await store.dispatch('app/setAppState', res.data);
      if (res.data) {
        if (res.data.status === 'downtime' && to.name !== 'Maintenance')
          return next({ path: '/under-maintenance' });
      } else if (!res.data && to.name === 'Maintenance') {
        return next({ path: '/login'});
      }
    })

  if (to.name === 'login') {
    return next();
  }

  const user = await store.dispatch('app/getUser');
  if (!user && protectedRoutes.includes(to.name)) {
    return next({ name: 'login' });
  }

  Vue.prototype.$user = user;

  let planID = 0;
  let licenceActive = false;
  let companyRoleId = 0;
  let optionalModules = {
    optional_module_1_id: null,
    optional_module_2_id: null,
    optional_module_3_id: null,
    optional_module_4_id: null,
  };

  if (user && user.company_id) {
    await store.dispatch("company/getCompanyLicence", { company_id: user.company_id })
      .then(res => {
        if (!res) {
          planID = 0;
          licenceActive = false;
          companyRoleId = 0;
          return;
        }

        planID = res.data != [] ? res.data[0].plan_id : 0,
        licenceActive = res.data != [] ? (res.data[0].licence_status == "ACTIVE" ? true : false) : false; // taking a chance with this one, might need to change if backend infra. goes a different way
        companyRoleId = res.data != [] ? (companyRoleId = res.data[0].company_role_id) : (companyRoleId = 0);
        optionalModules.optional_module_1_id = res.data[0].optional_module_1_id;
        optionalModules.optional_module_2_id = res.data[0].optional_module_2_id;
        optionalModules.optional_module_3_id = res.data[0].optional_module_3_id;
        optionalModules.optional_module_4_id = res.data[0].optional_module_4_id;
      })
      .catch(async () => {
        await store.dispatch("app/setCompanyLicence",
          {
            plan_id: planID,
            is_active: licenceActive,
            company_role_id: companyRoleId,
            optionalModules: optionalModules
          }
        );
      })
      .finally(async () => {
        await store.dispatch("app/setCompanyLicence",
          {
            plan_id: planID,
            is_active: licenceActive,
            company_role_id: companyRoleId,
            optionalModules: optionalModules
          }
        );
      });

    await store.dispatch('company/getAndSetCompanyLogo', {company_id: user.company_id});

  } else {
    await store.dispatch("app/setCompanyLicence",
      {
        plan_id: planID,
        is_active: licenceActive,
        company_role_id: companyRoleId
      }
    );
  }

  let roleID = null;

  if (user) {
    roleID = user.role_id;
  }

  if (user) {
    setupSteps();
    next();
    /* if (to.name == 'login') {
      // if the token exists but the user still tries to access 'login' / maybe this is not the best practice? not sure.
      next({ path: 'dashboard' });
    } else {
      next();
    } */
  } else if (!user && protectedRoutes.includes(to.name)) {
    // if the access token does not exist but the user tries to access token required pages
    next({ name: 'login' });
  } else {
    // if the token does not exists and the user tries to access unprotected pages such as "login", "register", "reset password" etc.
    next();
  }

  if (planID == 1 && licenceActive == true && starterNotAllowed.includes(to.name)) {
    // if the company is a starter plan company but tries to access higher plan pages
    next({ path: '/dashboard' });
  }
  if ((planID != 4 || (planID == 4 && licenceActive == false)) && enterpriseOnly.includes(to.name)) {
    // if the company is not not on 'enterprise' plan or is on 'enterprise' plan but with an inactive licence and tries to access enterprise only pages
    next({ path: '/dashboard' });
  }

  if (planID != -1 && auditorOnly.includes(to.name)) {
    // if the company is not an auditor but tries to access auditor routes.
    next({ path: '/dashboard' });
  } else if (planID == -1 && auditorOnly.includes(to.name) && to.name != 'Audited Companies' && !sessionStorage.getItem('audited_company_id')) {
    // if the company is an auditor but tries to access an auditor route that is not the company select screen when they haven't selected a company yet
    next({ path: '/audited-companies' });
  }
  if (roleID != 1 && adminOnly.includes(to.name)) {
    // if the company is not an admin but tries to access admin panel
    next({ path: '/dashboard' });
  }

  if (to.name === "Supplier Metrics" && companyRoleId == 6) {
    // if the company is a supplier but tries to access supplier metrics. /suppliers cannot have suppliers.
    next({ path: '/dashboard' });
  }

  if (to.path.includes('admin-panel')) {
    store.dispatch('app/setAdminPanel', true);
    next();
  } else {
    store.dispatch('app/setAdminPanel', false);
    next();
  }
});

export default router;
